import { GetToolUsageResponse } from "@/store/services/supabase";
import { useIsOwner } from "@/utils/hooks/useIsOwner";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Alert, Button } from "antd";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
const DetailsButton = () => <Link href="/settings/org/usage" target="_blank" rel="noreferrer" data-sentry-element="Link" data-sentry-component="DetailsButton" data-sentry-source-file="PortfolioExportFairUseWarning.tsx">
    <Button size="small" type="text" data-sentry-element="Button" data-sentry-source-file="PortfolioExportFairUseWarning.tsx">
      Details {<ArrowRightOutlined />}
    </Button>
  </Link>;
const PortfolioExportFairUseWarning = ({
  data
}: {
  data: GetToolUsageResponse;
}) => {
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "comprehensive.portfolioInsights.uploadLimitAlert"
  });
  const isOwner = useIsOwner();
  const currentUsage = data.singleQuotaMode && data.singleQuotaUsage ? data.singleQuotaUsage : data.portfolioInsights;

  // If max portfolio size not set
  if (data.quota === 0) {
    if (isOwner) return <></>;
    return <Alert type="error" className="mb-4" showIcon action={isOwner && <DetailsButton />} description={<div>
            Your organisation&apos;s portfolio size limit has not been configured by your administrator. Please request
            your <Link href="/settings/org/general">organisation&apos;s account owner</Link> to visit this page to
            resolve it.
          </div>} message="Portfolio size not configured" />;
  }
  return <>
      {currentUsage.showWarning === "warn" && <Alert type="warning" className="mb-4" showIcon action={isOwner && <DetailsButton />} message={<Markdown>{isOwner ? t("owner.warning") : t("user.warning")}</Markdown>} />}
      {currentUsage.showWarning === "error" && <Alert type="error" className="mb-4" showIcon action={isOwner && <DetailsButton />} message={<Markdown>{isOwner ? t("owner.error") : t("user.error")}</Markdown>} />}
    </>;
};
export default PortfolioExportFairUseWarning;